import { useEffect, useState } from 'react';
import { auth } from '../firebase/firebase';

export const useIsAdmin = () => {
    const [isAdmin, setIsAdmin] = useState<boolean | null>(null);
    const [isLoaded, setIsLoaded] = useState<boolean>(false);

    useEffect(() => {
        auth.authStateReady().then(() => {
            if (auth.currentUser) {
                auth.currentUser.getIdTokenResult().then((authTokenResult) => {
                    if (authTokenResult.claims.admin) {
                        setIsAdmin(true);
                        setIsLoaded(true);
                    } else {
                        setIsAdmin(false);
                        setIsLoaded(true);
                    }
                });
            } else {
                setIsAdmin(null);
                setIsLoaded(true);
            }
        });
    }, []);

    return [isAdmin, isLoaded];
};
